import React from 'react';
import { Flame, ShoppingBag, Heart, Sun, Moon, Menu } from 'lucide-react';

export default function NavBar({
  isDark,
  favoritesCount,
  cartCount,
  onToggleTheme,
}) {
  return (
    <nav
      className={`fixed w-full z-40 transition-all duration-500 backdrop-blur-md ${
        isDark
          ? 'bg-gray-900/90 border-b border-gray-700'
          : 'bg-white/90 border-b border-orange-200'
      }`}
    >
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='flex justify-between items-center py-4'>
          <div className='flex items-center space-x-3 group cursor-pointer'>
            <div
              className={`w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 ${
                isDark
                  ? 'bg-gradient-to-r from-orange-500 to-red-500'
                  : 'bg-gradient-to-r from-orange-400 to-red-400'
              } group-hover:scale-105`}
            >
              <Flame className='w-6 h-6 text-white animate-pulse' />
            </div>
            <div>
              <h1 className='text-xl font-bold bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent'>
                Свічкова Майстерня
              </h1>
              <p
                className={`text-xs ${
                  isDark ? 'text-gray-400' : 'text-gray-500'
                }`}
              >
                Натуральні свічки ручної роботи
              </p>
            </div>
          </div>

          <div className='hidden md:flex items-center space-x-6'>
            <a
              href='#home'
              className={`font-medium transition-colors ${
                isDark
                  ? 'text-gray-300 hover:text-orange-400'
                  : 'text-gray-700 hover:text-orange-600'
              }`}
            >
              Головна
            </a>
            <a
              href='#products'
              className={`font-medium transition-colors ${
                isDark
                  ? 'text-gray-300 hover:text-orange-400'
                  : 'text-gray-700 hover:text-orange-600'
              }`}
            >
              Каталог
            </a>
            <a
              href='#about'
              className={`font-medium transition-colors ${
                isDark
                  ? 'text-gray-300 hover:text-orange-400'
                  : 'text-gray-700 hover:text-orange-600'
              }`}
            >
              Про нас
            </a>
            <a
              href='#contact'
              className={`font-medium transition-colors ${
                isDark
                  ? 'text-gray-300 hover:text-orange-400'
                  : 'text-gray-700 hover:text-orange-600'
              }`}
            >
              Контакти
            </a>

            <div className='flex items-center space-x-3'>
              <button
                onClick={onToggleTheme}
                className={`p-2 rounded-lg transition-all duration-300 hover:scale-110 ${
                  isDark
                    ? 'bg-gray-800 hover:bg-gray-700'
                    : 'bg-orange-100 hover:bg-orange-200'
                }`}
              >
                {isDark ? (
                  <Sun className='w-5 h-5 text-yellow-400' />
                ) : (
                  <Moon className='w-5 h-5 text-gray-600' />
                )}
              </button>

              <div className='relative'>
                <Heart
                  className={`w-6 h-6 cursor-pointer transition-colors hover:scale-110 ${
                    isDark
                      ? 'text-gray-400 hover:text-red-400'
                      : 'text-gray-600 hover:text-red-500'
                  }`}
                />
                {favoritesCount > 0 && (
                  <span className='absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center'>
                    {favoritesCount}
                  </span>
                )}
              </div>

              <div className='relative'>
                <ShoppingBag
                  className={`w-6 h-6 cursor-pointer transition-colors hover:scale-110 ${
                    isDark
                      ? 'text-gray-400 hover:text-orange-400'
                      : 'text-gray-600 hover:text-orange-500'
                  }`}
                />
                {cartCount > 0 && (
                  <span className='absolute -top-2 -right-2 bg-orange-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center'>
                    {cartCount}
                  </span>
                )}
              </div>
            </div>
          </div>

          <button className='md:hidden'>
            <Menu className='w-6 h-6' />
          </button>
        </div>
      </div>
    </nav>
  );
}
